export enum StoreTransactionMode {
    Immediate = 0,
    Transactional = 1
}
